import { PersonEntity, WithUuid } from '@nk/data-entities-lib';
import * as dayjs from 'dayjs';

export function isPersonLikeEntity(item: unknown): item is PersonEntity {
  return (
    typeof item === 'object' &&
    item !== null &&
    item.hasOwnProperty('full_name') &&
    (item.hasOwnProperty('birth_date') || item.hasOwnProperty('birth_year'))
  );
}

export function hasPersonEntity(item: unknown): item is { person: WithUuid<PersonEntity> } {
  return (
    typeof item === 'object' &&
    item !== null &&
    item.hasOwnProperty('person') &&
    isPersonLikeEntity((item as unknown as { person: WithUuid<PersonEntity> }).person)
  );
}

export function getPersonAge<T extends { birth_date?: Date | null; birth_year?: number | null }>(entity: T): number {
  if (entity.birth_date) {
    return dayjs().diff(dayjs(entity.birth_date), 'year');
  } else if (entity.birth_year) {
    return dayjs().diff(dayjs().year(entity.birth_year), 'year');
  }
  return 0;
}
